<template>
  <div>
    <v-data-table
      :calculate-widths="true"
      dense
      :items="items"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100]
      }"
      :headers="headers"
      class="elevation-1"
      style="font-size:10px"
      :loading="loading"
      loading-text="Cargando... Por favor espere"
      :mobile-breakpoint="100"
      @update:pagination="updatePagination"
    >
      <template v-slot:item.ano="{ item }">
        <div class="text-center">
          {{ item.ano }}<br />
          <v-chip small outlined>
            {{ item.periodo }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.nombre_entidad="{ item }">
        <div>
          <span
            v-if="item.highlight && item.highlight.codigo_proceso"
            v-html="item.highlight.codigo_proceso.join('')"
          ></span>
          <span v-else>
            {{ item.codigo_proceso }}
          </span>

          <v-btn
            text
            icon
            x-small
            @click="copyToClipboard(item.codigo_proceso, item.url)"
          >
            <v-icon>mdi-link-variant</v-icon>
          </v-btn>

          <br />
          <strong>{{ item.estado }}</strong>
          <br />
          <strong>Fecha publicación: </strong>{{ item.fecha_publicacion }}
          <v-divider class="my-2 white background"></v-divider>

          <span
            v-if="item.highlight && item.highlight.nombre_entidad"
            v-html="item.highlight.nombre_entidad.join('')"
          ></span>
          <span v-else>
            {{ item.nombre_entidad }}
          </span>
          {{
            item.nombre_entidad != item.nombre_comercial_entidad
              ? ` [${item.nombre_comercial_entidad}]`
              : ""
          }}
          <br />
          <v-chip small outlined>
            <v-icon small left>mdi-map-marker</v-icon>
            {{ item.provincia_entidad }} / {{ item.canton_entidad }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.descripcion="{ item }">
        <div class="py-2">
          <v-chip small outlined class="mr-1">
            {{ item.procedimiento | uppercase }}
          </v-chip>
          <v-chip small outlined>
            {{ item.pac_tipo | uppercase }}
          </v-chip>
          <br />

          <strong>OBJETO DEL PROCESO: </strong>
          <span
            v-if="item.highlight && item.highlight.objeto_proceso"
            v-html="item.highlight.objeto_proceso.join('')"
          ></span>
          <span v-else>
            {{ item.objeto_proceso }}
          </span>
          <v-divider class="my-2 background"></v-divider>

          <strong>DESCRIPCION DEL ITEM: </strong> [
          <strong>{{ item.item_no }} </strong>
          de
          <strong>{{ item.total_items }} </strong> ]
          <span
            v-if="item.highlight && item.highlight.descripcion"
            v-html="item.highlight.descripcion.join('')"
          ></span>
          <span v-else>
            {{ item.descripcion }}
          </span>
          <v-btn
            color="primary"
            v-if="item.total_items > 1"
            class="ma-2"
            sm
            outlined
            x-small
            v-on:click="addFilter('codigo_proceso', item.codigo_proceso)"
          >
            VER TODOS LOS ITEMS DE ESTE PROCESO
          </v-btn>
          <v-divider class="my-2 background"></v-divider>
          <strong>CPC NIVEL 5: </strong>
          <span
            v-if="item.highlight && item.highlight.descripcion_cpc"
            v-html="item.highlight.descripcion_cpc.join('')"
          ></span>
          <span v-else>
            {{ item.descripcion_cpc }}
          </span>

          <v-divider class="my-2 background"></v-divider>
          <strong>CPC NIVEL 9: </strong>
          <span
            v-if="item.highlight && item.highlight.descripcion_cpc_full"
            v-html="item.highlight.descripcion_cpc_full.join('')"
          ></span>
          <span v-else>
            {{ item.descripcion_cpc_full }}
          </span>
        </div>
      </template>
      <template v-slot:item.pac_total="{ item }">
        <div class="d-flex justify-space-between">
          Cant.
          <span>{{ item.pac_cantidad | currency("") }}</span>
        </div>
        <div class="d-flex justify-space-between">
          Medida.
          <span>{{ item.pac_medida }}</span>
        </div>
        <div class="d-flex justify-space-between">
          V. Unit
          <span class="border-t">
            {{
              item.pac_costo_unitario
                | currency("$", 2, {
                  spaceBetweenAmountAndSymbol: true
                })
            }}</span
          >
        </div>
        <v-divider class="my-0 black"></v-divider>
        <div class="d-flex justify-space-between font-weight-bold">
          Total
          <span>
            {{
              item.pac_total
                | currency("$", 2, { spaceBetweenAmountAndSymbol: true })
            }}</span
          >
        </div>

        <!-- <v-row no-gutters>
          <v-col>Cant.</v-col>
          <v-col class="text-right">{{
            item.pac_cantidad | currency("")
          }}</v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>Medida.</v-col>
          <v-col class="text-right">{{ item.pac_medida }}</v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>V. Unit</v-col>
          <v-col class="text-right">{{
            item.pac_costo_unitario
              | currency("$", 2, { spaceBetweenAmountAndSymbol: true })
          }}</v-col>
        </v-row>
        <v-row no-gutters>
          <v-col><strong>Total</strong></v-col>
          <v-col style="border-top:1px solid" class="text-right">
            <strong
              >{{
                item.pac_total
                  | currency("$", 2, { spaceBetweenAmountAndSymbol: true })
              }}
            </strong></v-col
          >
        </v-row> -->
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :vertical="true" color="secondary">
      <div v-html="snackbarText"></div>
      <v-btn outlined color="blue accent-2" @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { getFilterByValue } from "@/assets/columns";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "transito-table",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: Boolean
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      headers: [
        { text: "PERIODO", value: "ano", width: "77" },
        {
          text: "INFORMACIÓN DEL PROCESO / CONTRATANTE / LOCALIDAD",
          value: "nombre_entidad",
          width: "300"
        },
        {
          text: "OBJETO DE LA CONTRATACIÓN / DESCRIPCIÓN DEL ITEM",
          value: "descripcion"
        },
        { text: "CANT. Y PRECIO REF.", value: "pac_total", width: "180" }
      ]
    };
  },
  computed: {
    ...mapGetters(["filters"])
  },
  methods: {
    ...mapActions(["addFilterAction"]),
    addFilter(value, param) {
      let filter = {};
      filter.field = getFilterByValue(value);
      filter.param = param;
      this.addFilterAction(filter);
      this.snackbarText = `Se agregó un filtro <strong>${filter.field.label.toUpperCase()}</strong>.`;
      this.snackbar = true;
      //console.log(filter);
    },
    updatePagination: function(pagination) {
      console.log("update:pagination", pagination);
    },
    copyToClipboard: function(codigo_proceso, url) {
      let that = this;
      this.$copyText(url).then(
        function() {
          that.snackbarText = `La url del proceso <strong>${codigo_proceso}</strong> se ha copiado al portapapeles.`;
          that.snackbar = true;
        },
        function() {
          that.snackbarText = `Error al intentar copiar la url del proceso ${codigo_proceso}  al portapapeles`;
          that.snackbar = true;
        }
      );
    }
  },
  mounted() {}
};
</script>
